export default __webpack_public_path__ + "static/our-values-2-18ad5edd054f915cfdf897e2e896d272.svg";